<template>
  <div>
    <div class="alert alert-warning ImagePickerImagePicker--alert" v-if="limitMaxOfSelectedImages > 1">
      <div class="alert-text d-flex justify-content-between align-items-center">
        <div>
          Please, select a minimum of <strong>{{ limitMinOfSelectedImages }}</strong> images or a maximum of <strong>{{ limitMaxOfSelectedImages }}</strong>. So far you have selected <strong>{{ lenSelected }}</strong>.
        </div>
        <button
          class="btn btn-sm btn-primary"
          v-if="lenSelected >= limitMinOfSelectedImages"
          @click="onClose">Done</button>
      </div>
    </div>
    <ImagePickerAlert v-if="isSearching">
      <font-awesome-icon :icon="['fas', 'spinner']" size="4x" spin />
    </ImagePickerAlert>
    <div class="gallery" v-else>
      <ImagePickerImageGridItem
        v-for="image in data"
        :key="image.assetId"
        :data="image"
        :selected="imagesSelected.map(s => s.assetId).indexOf(image.assetId)"
        @onSelectImage="onSelectImage" />
      <ImagePickerImageGridItem
        v-for="(image, index) in (1, resto)"
        :key="`${image.assetId}_${index}`"
        :data="{}"
        :disabled="true" />
    </div>
  </div>
</template>

<script>
import ImagePickerImageGridItem from './ImagePickerImageGridItem.vue'
import ImagePickerAlert from './ImagePickerAlert.vue'

export default {
  name: 'ImagePickerImageGrid',
  data () {
    return {
      imagesSelected: []
    }
  },
  components: {
    ImagePickerImageGridItem,
    ImagePickerAlert
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    imagesByPage: {
      type: Number,
      default: 21
    },
    limitMinOfSelectedImages: {
      type: Number,
      required: false
    },
    limitMaxOfSelectedImages: {
      type: Number,
      default: 1
    }
  },
  computed: {
    resto () {
      if (this.data && Array.isArray(this.data)) {
        return this.imagesByPage - Number(this.data.length)
      }
      return this.imagesByPage
    },
    lenSelected () {
      const arr = this.imagesSelected.map(s => s.assetId)
      return arr.length
    }
  },
  methods: {
    onSelectImage (imageSelected) {
      if (this.limitMaxOfSelectedImages === 1) {
        this.imagesSelected = imageSelected
      }
      // DONE: Busco en la lista de imagenes y si existe la remuevo sino lo agrego a la lista
      if (Array.isArray(this.imagesSelected)) {
        const imageExists = this.imagesSelected.map(s => s.assetId).indexOf(imageSelected.assetId)
        if (imageExists > -1) {
          this.imagesSelected.splice(imageExists, 1)
        } else {
          if (this.lenSelected < this.limitMaxOfSelectedImages) {
            this.imagesSelected.push(imageSelected)
          }
        }
      }
      this.$emit('onSelectImage', this.imagesSelected)
    },
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: .5em;
}
.ImagePickerImagePicker--alert {
  background-color: #ffc;
  margin-bottom: 10px;
  border: 1px solid #ff0;
  padding: .6rem 2rem;
}
</style>
